/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminActivityFillRateBySportDto { 
    /**
     * Sport identifier
     */
    sportId: string;
    /**
     * Sport name in French
     */
    sportNameFr: string;
    /**
     * Sport name in English
     */
    sportNameEn: string;
    /**
     * Activities created for this sport, excluding deleted ones
     */
    activities: number;
    /**
     * Realistic capacity for this sport, taken from its own definition rather than from what organisers typed. Null when the sport has no definition, in which case the adjusted rate is not computed.
     */
    referenceCapacity: number | null;
    /**
     * Average capacity organisers actually typed on their activities
     */
    averageDeclaredCapacity: number;
    /**
     * Average number of people on an activity, organiser included
     */
    averageAttendees: number;
    /**
     * Average attendees over the sport reference capacity, as a percentage. Null without a reference.
     */
    adjustedFillRate: number | null;
    /**
     * Average attendees over the capacity organisers typed, as a percentage
     */
    declaredFillRate: number;
    /**
     * Activities nobody ever joined, organiser alone
     */
    neverJoined: number;
    /**
     * Share of activities nobody ever joined, as a percentage
     */
    neverJoinedShare: number;
}

